export default __webpack_public_path__ + "static/media/ic_timeline_step_complete.fb97ec81.svg";